import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import analytics from '@/shared/api/analytics';

const PageTracker = (): any => {
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    // Track page view
    const pageTitle = document.title || location.pathname;
    analytics.pageView(pageTitle);

    // Set user if logged in
    if (user?.id) {
      analytics.setUser(user.id);
    }
  }, [location.pathname, location.search, user]);

  // Heartbeat every 30 seconds for online users tracking
  useEffect(() => {
    analytics.heartbeat();
    const interval = setInterval(() => {
      analytics.heartbeat();
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  return null;
};

export default PageTracker;
